import { motion } from "framer-motion";
import { ChevronUp, ChevronDown, Share2, TrendingUp, MessageSquare } from "lucide-react";

const POSTS = [
  {
    id: 1,
    sport: "Cricket",
    color: "#3B9EFF",
    bgGradient: "from-[#0D1F0D] to-[#111]",
    user: "RohitFanatic",
    avatar: "https://images.unsplash.com/photo-1767783703531-536ea0c32478?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwZmFuJTIwYXZhdGFyJTIwSW5kaWElMjBqZXJzZXklMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzQ1MzcyODR8MA&ixlib=rb-4.1.0&q=85",
    time: "5 min ago",
    content: "Virat Kohli's 50th Test century was just pure genius! The way he paced the innings — absolute master class.",
    image: "https://images.pexels.com/photos/3602833/pexels-photo-3602833.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600",
    upvotes: "24.3k",
    responses: "1.8k",
    tag: "IND vs AUS",
    span: "md:col-span-5",
  },
  {
    id: 2,
    sport: "Football",
    color: "#007AFF",
    bgGradient: "from-[#0A0A1F] to-[#111]",
    user: "GoalKingFC",
    avatar: "https://images.unsplash.com/photo-1757773874306-e80bcf6dc307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxmb290YmFsbCUyMHNvY2NlciUyMGF2YXRhciUyMGZhbiUyMHBvcnRyYWl0JTIwc3RhZGl1bXxlbnwwfHx8fDE3NzQ1MzcyODd8MA&ixlib=rb-4.1.0&q=85",
    time: "22 min ago",
    content: "Haaland breaks another Champions League record! 50 CL goals before turning 26 — this man is from another planet.",
    image: "https://images.unsplash.com/photo-1583505996159-307082cf2085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxmb290YmFsbCUyMHBsYXllciUyMGFjdGlvbiUyMG5pZ2h0JTIwc3RhZGl1bXxlbnwwfHx8fDE3NzQ1MzQzNDJ8MA&ixlib=rb-4.1.0&q=85",
    upvotes: "18.7k",
    responses: "940",
    tag: "Champions League",
    span: "md:col-span-7",
  },
  {
    id: 3,
    sport: "Esports",
    color: "#a855f7",
    bgGradient: "from-[#180A1F] to-[#111]",
    user: "BGMIPro99",
    avatar: "https://images.unsplash.com/photo-1673669231301-09baa4d7761b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxnYW1pbmclMjBoZWFkc2V0JTIwZXNwb3J0cyUyMHBsYXllciUyMHNldHVwJTIwZGFya3xlbnwwfHx8fDE3NzQ1MzcyODd8MA&ixlib=rb-4.1.0&q=85",
    time: "1 hr ago",
    content: "BGMI National Finals results are in! Team Alpha dominates with 45 kill points. India's best squad right now!",
    image: "https://images.pexels.com/photos/6963945/pexels-photo-6963945.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600",
    upvotes: "32.1k",
    responses: "2.1k",
    tag: "BGMI Finals",
    span: "md:col-span-6",
  },
  {
    id: 4,
    sport: "Trending",
    color: "#3B9EFF",
    bgGradient: "from-[#131300] to-[#111]",
    user: "SportsDesk24",
    avatar: "https://images.unsplash.com/photo-1554941829-1a16e65a02b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBuZXdzJTIwbWljcm9waG9uZSUyMGJyb2FkY2FzdCUyMGpvdXJuYWxpc3R8ZW58MHx8fHwxNzc0NTM3Mjg5fDA&ixlib=rb-4.1.0&q=85",
    time: "2 hr ago",
    content: "IPL 2025 mega auction results confirmed! 3 players sell for record ₹24 crore each. The T20 league just got bigger.",
    image: null,
    upvotes: "41.5k",
    responses: "3.2k",
    tag: "IPL 2025",
    span: "md:col-span-6",
  },
];

function PostCard({ post, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay }}
      className={`${post.span} bg-[#171B24] border border-white/5 hover-glow rounded-2xl overflow-hidden group cursor-default hover:-translate-y-2 transition-transform duration-150`}
    >
      {post.image && (
        <div className="relative h-44 overflow-hidden">
          <img
            src={post.image}
            alt={post.sport}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#171B24] via-transparent to-transparent" />
          <span
            className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full"
            style={{ background: `${post.color}22`, color: post.color, border: `1px solid ${post.color}44` }}
          >
            {post.tag}
          </span>
        </div>
      )}
      <div className="p-5">
        {!post.image && (
          <span
            className="text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full mb-4 inline-block"
            style={{ background: `${post.color}22`, color: post.color, border: `1px solid ${post.color}44` }}
          >
            {post.tag}
          </span>
        )}
        <div className="flex items-center gap-2.5 mb-3">
          <img
            src={post.avatar}
            alt={post.user}
            className="w-8 h-8 rounded-full object-cover flex-shrink-0 ring-2 ring-white/10"
          />
          <div>
            <div className="text-white text-sm font-semibold">{post.user}</div>
            <div className="text-[#A1A1AA] text-xs">{post.time}</div>
          </div>
        </div>
        <p className="text-[#D4D4D4] text-sm leading-relaxed mb-4">{post.content}</p>
        <div className="flex items-center gap-3 pt-3 border-t border-white/5">
          {/* Upvote / Downvote pill */}
          <div className="flex items-center bg-white/[0.05] border border-white/[0.08] rounded-full overflow-hidden">
            <button className="flex items-center gap-1.5 px-3 py-1.5 hover:bg-[#3B9EFF]/15 transition-colors duration-150 group/up">
              <ChevronUp size={14} className="text-[#A1A1AA] group-hover/up:text-[#3B9EFF] transition-colors duration-150" />
              <span className="text-xs font-bold text-[#A1A1AA] group-hover/up:text-[#3B9EFF] transition-colors duration-150 tabular-nums">
                {post.upvotes}
              </span>
            </button>
            <div className="w-px h-5 bg-white/10" />
            <button className="flex items-center px-2.5 py-1.5 hover:bg-red-500/15 transition-colors duration-150 group/down">
              <ChevronDown size={14} className="text-[#A1A1AA] group-hover/down:text-red-400 transition-colors duration-150" />
            </button>
          </div>

          {/* Responses */}
          <span className="flex items-center gap-1.5 text-xs text-[#A1A1AA]">
            <MessageSquare size={13} className="opacity-60" />
            {post.responses} Responses
          </span>

          {/* Share */}
          <button className="ml-auto flex items-center gap-1 text-xs text-[#A1A1AA] hover:text-white transition-colors duration-150">
            <Share2 size={13} />
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default function CommunitySection() {
  return (
    <section id="community" data-testid="community-section" className="py-24 lg:py-32 bg-[#0C0E13]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#3B9EFF]" />
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-[#3B9EFF] font-outfit">Live Community</span>
            <span className="flex items-center gap-1.5 bg-[#3B9EFF]/10 border border-[#3B9EFF]/30 rounded-full px-2.5 py-0.5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#3B9EFF]" />
              <span className="text-[9px] font-black uppercase tracking-wider text-[#3B9EFF]">At Launch</span>
            </span>
          </div>
          <h2 className="font-outfit font-bold text-4xl sm:text-5xl tracking-tight text-white mb-4">
            Your Sports Feed,<br />
            <span className="text-[#3B9EFF]">Reimagined</span>
          </h2>
          <p className="text-base md:text-lg text-[#A1A1AA] max-w-xl font-inter">
            Real-time posts, hot takes, match highlights, and fan conversations — all in one place.
          </p>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {POSTS.map((post, i) => (
            <PostCard key={post.id} post={post} delay={i * 0.12} />
          ))}
        </div>

        {/* Stats bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10 grid grid-cols-3 gap-4 bg-[#171B24] border border-white/5 rounded-2xl p-6"
        >
          {[
            { icon: TrendingUp, label: "Posts Today", value: "52,481" },
            { icon: ChevronUp, label: "Total Upvotes", value: "1.2M+" },
            { icon: MessageSquare, label: "Responses", value: "340K+" },
          ].map(({ icon: Icon, label, value }, i) => (
            <div key={label} className="text-center">
              <Icon size={18} className="text-[#3B9EFF] mx-auto mb-2" />
              <div className="text-white font-outfit font-bold text-xl">{value}</div>
              <div className="text-[#A1A1AA] text-xs mt-0.5">{label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
